export default "__VITE_ASSET__Dj36ytNC__"